// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"7b7c4f0f","89":"119a3d7e","218":"6f3b0c16","411":"bdd4a512","506":"87c30488","516":"064ef164","616":"62097acf","698":"a87d8a59","730":"f9bd4b31","917":"2adc9cef","934":"c6a628a5","956":"816754f9"}[chunkId] + ".chunk.js";
};